import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import ScrollToTopButton from "./ScrollToTopButton";
import { Phone, Mail, MapPin } from "lucide-react";
import { useSiteConfig } from "@/hooks/useSiteConfig";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { getConfig } = useSiteConfig();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <WhatsAppFloat />
      <ScrollToTopButton />
    </div>
  );
};

export default Layout;